"use client";

import { CREATOR_WARNING_POLICY_URL } from "@artha/types";
import { useMyLinkProfileQuery } from "@/modules/creator/services/creatorClient";
import { CreatorTopBanner } from "./CreatorTopBanner";

export function CreatorWarningBanner() {
  const { data: creatorProfile } = useMyLinkProfileQuery();
  const message = creatorProfile?.warning?.message;

  if (!message) return null;

  return (
    <CreatorTopBanner
      tone="warning"
      role="alert"
      testId="creator-warning-banner"
    >
      {message}{" "}
      <a
        href={CREATOR_WARNING_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-bold text-amber-800 underline underline-offset-2"
      >
        Read more
      </a>
    </CreatorTopBanner>
  );
}
